

const ACTIVITIES_TYPE_URI_PUBLIC = '/p/api/activities-type';
const ACTIVITIES_TYPE_URI = '/api/admin/activities-type';
const ACTIVITY_TYPE_URI = '/api/admin/activity-type';
const ACTIVITIES_URI = '/api/admin/activities';
const ACTIVITY_URI = '/p/api/activity';
const ACTIVITY_CHECKIN_URI = '/p/api/activity-checkin';
const ACTIVITY_CHECKIN_FILE_URI ='/p/api/activity-checkin-file';
const ACTIVITY_MANAGE ='/p/api/activity-manage';
const ACTIVITY_DELETE_URI = '/api/admin/activity';

export const ActivitiesApi = {
    async getAllActivitiesTypePublic() {
        const response = await axios.get(`${ACTIVITIES_TYPE_URI_PUBLIC}`);
        console.log(response);
        return response.data;
    },

    async deleteActivity(id) {
        const response = await axios.delete(`${ACTIVITY_DELETE_URI}?id=`+id);
        console.log(response);
        return response.data;
    },


    async getAllActivitiesType() {
        const response = await axios.get(`${ACTIVITIES_TYPE_URI}`);
        console.log(response);
        return response.data;
    },
    async saveActivityType(objet) {
        const response = await axios.post(`${ACTIVITY_TYPE_URI}`, objet);
        console.log(response);
        return response.data;
    },
    async getAllActivities() {
        const response = await axios.get(`${ACTIVITIES_URI}`);
        console.log(response);
        return response.data;
    },
    async createActivity(objet) {
        const response = await axios.post(`${ACTIVITY_URI}`, objet
          ,{headers: { 'Content-Type': 'multipart/form-data'}});
        console.log(response);
        return response.data;
    },
    async activityManage(uuid) {
        const response = await axios.get(`${ACTIVITY_MANAGE}?uuid=`+uuid);
        return response.data;
    },
    async activityUnitCheckin(uuid, id) {
        const response = await axios.get(`${ACTIVITY_CHECKIN_URI}?uuid=`+uuid+'&id='+id);
        return response.data;
    },
    async activityCheckinFile(uuid,objet) {
        const response = await axios.post(`${ACTIVITY_CHECKIN_FILE_URI}?uuid=`+uuid, objet
          ,{headers: { 'Content-Type': 'multipart/form-data'}});
        console.log(response);
        return response.data;
    },


};
